import {h, Fragment} from "preact"
import Product from "./Product"
import { useAppState } from "@nosto/preact"

export default function Products() {
    const {
        response: { products },
        loading
    } = useAppState()

    return (
        <div class="ns-d-flex ns-flex-wrap product-listing" style={loading ? "opacity: 0.3;" : ""}>
            {products.hits.map((hit, index) => {
                return <Product product={hit} key={hit.productId || index} />
            })}
        </div>
    )
}
